import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR} from '../theme.js';

export function getBetHistoryConfig() {
    return {
        palette: {
            [PALETTE_IDS.BET_HISTORY]: {
                BET_HISTORY_EMPTY_CONTENT_MESSAGE: {
                    EMPTY_CONTENT_MESSAGE_TEXT: COLOR.BRAND.FOREGROUND2,
                },
                BET_HISTORY_ERROR_TEXT: COLOR.BRAND.FOREGROUND2,
                BET_HISTORY_MOBILE_EMPTY_CONTENT_MESSAGE: {
                    EMPTY_CONTENT_MESSAGE_TEXT: COLOR.BRAND.FOREGROUND2,
                },
                BET_HISTORY_MOBILE_ERROR_TEXT: COLOR.BRAND.FOREGROUND2,
            },
        },
    };
}
